import { mapLabelValueBadge } from '@@viewHelpers/string.js';
import {
  __,
  always,
  anyPass,
  complement,
  compose,
  concat,
  equals,
  filter,
  isEmpty,
  isNil,
  map,
  pathOr,
  prepend,
  prop,
  propOr,
  unless
} from 'ramda';
import PropTypes from 'prop-types';
import { Icon, Row } from '@fasstech/middle-design-system';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import React from 'react';

const refundIndividualHealth = ({
  project,
  editSouscription3,
  getMiddleText,
  getMiddleBoolean
}) => {
  const customer = propOr({}, 'customer', project);
  const grantees = propOr([], 'grantees', project);
  const getIban = pathOr('-', ['bankAccounts', 0, 'iban']);

  const isInvalidIban = anyPass([isNil, isEmpty, equals('-')]);
  const options = compose(
    unless(
      always(isInvalidIban(getIban(customer))),
      prepend([getMiddleText('REFUND_IBAN_LABEL'), getIban(customer)])
    ),
    unless(
      always(
        !getMiddleBoolean('PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_RIB_BENEFICIAIRE_EST_NECESSAIRE')
      ),
      compose(
        concat(__),
        map((grantee) => [
          getMiddleText('REFUND_IBAN_LABEL'),
          getIban(grantee),
          prop('firstName', grantee)
        ]),
        filter(compose(complement(isInvalidIban), getIban))
      )(grantees)
    )
  )([]);

  return (
    <>
      <div className="border border-[#E7E7E7] rounded-md w-full">
        <div className={'w-full flex justify-between items-center p-4 border-b'}>
          <div className={'font-bold'}>
            {getMiddleText('RECAPITULATIF_REFUND_INFORMATIONS_TITLE')}
          </div>
          <Icon
            name={'circlePen'}
            size={30}
            className={'cursor-pointer'}
            onClick={editSouscription3}
          />
        </div>
        <div className="flex flex-col gap-4 w-full p-4">
          {mapIndexed((item, index) => <Row item={item} index={index} />)(
            mapLabelValueBadge(options)
          )}
        </div>
      </div>
    </>
  );
};

refundIndividualHealth.propTypes = {
  project: PropTypes.object,
  editSouscription3: PropTypes.func,
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func
};

export default refundIndividualHealth;
